import { render } from "./AuthorNotification.vue?vue&type=template&id=450ac988&scoped=true"
const script = {}

import "./AuthorNotification.vue?vue&type=style&index=0&id=450ac988&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450ac988"]])

export default __exports__